<script>
import { authComputed, authMethods } from '@state/helpers'
import OtpInput from './otp-input.vue'
import axios from 'axios'
import { userService } from '@/src/services/UserService'
import store from '@/src/state/store'
import Form from '@classes/Form'

export default {
  page: {
    meta: [{ name: 'description', content: 'The 2FA page.' }],
  },
  components: { OtpInput },
  data() {
    return {
      tryingToChange: false,
      authError: null,
      success: '',
      enterCode: false,
      userForm: new Form({
        first_name: '',
        last_name: '',
        gender: '',
        sex: '',
        credential: '',
        dob: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone_number: '',
        imperial_units: '',
        has_mfa_enabled: false,
      }),
    }
  },

  computed: {
    ...authComputed,
    choice() {
      return this.serializedUser.mfa_devices[0]?.device_type
    },
  },
  mounted() {},
  methods: {
    ...authMethods,
    async changeMfa(intent) {
      try {
        this.tryingToChange = true
        if (intent && !this.hasMfa) {
          // 1. register device

          this.$router.push({ name: '2fa.register' })
        } else {
          this.authError = null
          if (this.choice === 'email') {
            const response = await axios.post('/api/v1/mfa/generate/')
            if (response.status === 200) {
              this.enterCode = true
            }
          } else {
            this.enterCode = true
          }
        }
      } catch (error) {
        this.authError = error
      } finally {
        this.tryingToChange = false
      }
    },
    async disable2fa(code) {
      try {
        // 1. Make sure verification code is ok
        const verifyResponse = await axios.post('/api/v1/verify/', {
          code: code,
        })

        if (verifyResponse.status === 200) {
          // 2. Delete MFA Device
          const deviceUuid = this.serializedUser.mfa_devices[0].uuid
          const response = await axios.delete(`/api/v1/mfa/${deviceUuid}`)
          if (response.status === 200) {
            const userData = JSON.parse(localStorage.getItem('userData'))
            userData.has_mfa_enabled = true
            this.userForm.first_name = userData.first_name
            this.userForm.last_name = userData.last_name
            this.userForm.gender = userData.gender.key
            this.userForm.sex = userData.sex.key
            this.userForm.credential = userData.credential
            this.userForm.dob = userData.dob
            this.userForm.email = userData.email
            this.userForm.address = userData.address
            this.userForm.city = userData.city
            this.userForm.state = null
            this.userForm.zip = userData.zip_code
            this.userForm.phone_number = userData.phone_number
            this.userForm.imperial_units = userData.imperial_units
            this.userForm.has_mfa_enabled = false

            await userService.update(
              this.serializedUser.user_id,
              this.userForm.data()
            )
            await store.dispatch('auth/fetchUser')
            this.success = 'Two-Factor Authentication successfully disabled!'
            this.enterCode = false
          }
        }
      } catch (error) {
        this.authError = error
        throw new Error(`Problem handling something: ${error}`)
      }
    },
  },
}
</script>

<template>
  <v-card outlined rounded="xl" class="pa-2" :class="$style.cardContainer">
    <v-card-text>
      <v-row no-gutters>
        <v-switch
          :loading="tryingToChange"
          :label="
            hasMfa
              ? 'Disable Two-Factor Authentication (2FA)'
              : 'Enable Two-Factor Authentication (2FA)'
          "
          :input-value="hasMfa"
          @change="changeMfa"
        ></v-switch>
      </v-row>
      <v-row v-if="enterCode" class="mb-5">
        <p>Please enter your verification code to proceed</p>
        <OtpInput
          :class="authError ? $style.invalid : ''"
          @input="disable2fa"
        ></OtpInput>
      </v-row>

      <div v-if="success" class="success--text mt-5">
        {{ success }}
      </div>
      <div v-if="authError" class="alert alert-danger mt-5" role="alert">
        {{ authError.response.data }}
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.invalid {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

.cardContainer {
  background-color: transparent !important;
  border: 0 !important;
}

/* also need keyframes and -moz-keyframes */
@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
